import { AppModule } from 'app/module';
import { app } from 'app/app';
import { BsCompanyBenefitsItem } from 'module/bsCompanyBenefitsItem/main';
import { mediaQueries } from 'util/mediaQueries';
import 'module/icon/main';
import Template from './template.hbs';
import './styles.scss';

export class BsCompanyBenefitsList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        app.events.on('onWindowResize', () => this.onWindowResize());
    }

    domBindings() {
        return {
            benefitsItems: ['.m-bsCompanyBenefitsItem'],
            categoryBlock: '.m-bsCompanyBenefitsList__categoryBlock',
            categoryTitle: '.m-bsCompanyBenefitsList__categoryTitle',
            benefitsBlock: '.m-bsCompanyBenefitsList__benefitsBlock',
            closeTrigger: '.m-bsCompanyBenefitsList__closeTrigger',
        };
    }

    getPropsFromDom() {
        const newProps = {
            icon: {},
        };

        const iconType = this.dom.categoryBlock ? this.dom.categoryBlock.getAttribute('data-icon-type') : '';
        newProps.icon[iconType] = true;

        return { active: this.dom.el.classList.contains('m-bsCompanyBenefitsList--active'),
            category: !!this.dom.categoryBlock,
            categoryTitle: this.dom.categoryTitle ? this.dom.categoryTitle.innerText : '',
            modalOpen: this.dom.benefitsBlock
                ? !this.dom.benefitsBlock.classList.contains('m-bsCompanyBenefitsList__benefitsBlock--hide') : false,
            isCentered: this.dom.el ? this.dom.el.classList.contains('m-bsCompanyBenefitsList--center') : false,
            iconType,
            ...newProps };
    }

    domEvents() {
        if (this.dom.categoryBlock) {
            this.dom.categoryBlock.addEventListener('click', () => this.openModalViaClick());
        }

        if (this.dom.closeTrigger) {
            this.dom.closeTrigger.addEventListener('click', () => this.closeModalViaClick());
        }
    }

    subs() {
        if (this.dom.benefitsItems) {
            const benefitProps = {
                benefitItem: {},
            };
            this.benefitsItems = [];

            for (let i = 0; i < this.dom.benefitsItems.length; i += 1) {
                const newBenefitItems = new BsCompanyBenefitsItem(this.dom.benefitsItems[i]);

                benefitProps.benefitItem[i] = {};
                benefitProps.benefitItem[i] = newBenefitItems.getPropsFromDom();
                this.benefitsItems.push(newBenefitItems);
            }
            this.props = Object.assign(this.props, benefitProps);
        }
    }

    openModal() {
        if (mediaQueries.isMobile()) {
            this.updateProps({ modalOpen: true }, true);
            this.events.emit('openModal');
        }
    }

    openModalViaClick() {
        if (mediaQueries.isMobile()) {
            this.updateProps({ modalOpen: true }, true);
            this.events.emit('openModal');
            this.events.emit('pushState');
        }
    }

    closeModal() {
        this.updateProps({ modalOpen: false }, true);
        this.events.emit('closeModal');
    }

    closeModalViaClick() {
        window.history.back();
    }

    onWindowResize() {
        if (!mediaQueries.isMobile() && this.props.modalOpen) {
            this.closeModal();
        }
    }
}
